// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentAutomations/update-event-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_TreatmentAutomations(
  $id: uuid!
  $name: String
  $type: String!
  $automation_type: String!
  $trigger_type: String!
  $data: jsonb!
  $actions: [automations_update_automation_actions_input!]!
) {
  automations_update_automation(
    id: $id
    name: $name
    type: $type
    automation_type: $automation_type
    trigger_type: $trigger_type
    data: $data
    actions: $actions
  ) {
    event_id
  }
}

`